export { NileTabGroup } from './nile-tab-group';
